import { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import apiClient from "../../apiClient";
import Select from "react-select";
import { useSelector } from "react-redux";
import { FETCH_AR_MODULE_DETAIL, UPDATE_AR_MODULE_DETAIL } from "../../apiClient/apiEndpoints";
import axios from "axios";
import { SpinnerIcon } from "../../Static/icons/iconshere";
import { debounce } from "../../utils/useWindowDimensions";
import { FoldDown, FoldRight } from "../../Static/icons/iconshere";
import { arContentTypeOptions, imageFileTypes } from "../../utils/constants";
import { getAllowedMaxFileSize, isFileSizeOverMaxSize } from "../../utils/common";
import { AR_CONTENT_THUMBNAIL } from "../../constant/limitSize";

const ARDetails = ({ uuid, setShowMediaContent, threeDModelsList }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const UNO_URL = configData?.config?.UNO_URL;
  const [showProgress, setShowProgress] = useState(false);
  const [key, setKey] = useState(0);
  const [fileError, setFileError] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [close, setClose] = useState(false);
  const [arContentMode, setArContentMode] = useState("model");
  const [moduleDetails, setModuleDetails] = useState({
    name: "",
    thumbnail: "",
    description: "",
    arType: [],
  });

  const fetchBasicModuleDetails = async () => {
    try {
      const detail = await apiClient.get(`${UNO_URL}${FETCH_AR_MODULE_DETAIL}/${uuid}`);

      let selectedArTypes = detail?.versions?.[0]?.data?.type;
      selectedArTypes = Array.isArray(selectedArTypes) ? selectedArTypes : [selectedArTypes];

      setModuleDetails({
        name: detail?.name || "",
        description: detail?.versions?.[0]?.data?.description || "",
        thumbnail: detail?.versions?.[0]?.data?.thumbnail || "",
        arType: arContentTypeOptions.filter((option) => selectedArTypes.includes(option.value)),
      });

      setArContentMode(detail?.versions?.[0]?.data?.contentMode || "hotspot");

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBasicModuleDetails();
  }, [uuid]);

  useEffect(() => {
    setShowMediaContent((moduleDetails.arType).map(e => e.value));
  }, [moduleDetails]);

  const handleImageUpload = async (file) => {

    if (isFileSizeOverMaxSize(file.size, AR_CONTENT_THUMBNAIL)) {
      setKey((pre) => pre + 1);
      setFileError(`File size is more then ${getAllowedMaxFileSize(AR_CONTENT_THUMBNAIL)}`);
      return
    }

    if (showProgress) return;
    try {
      if (!file || !file.type.startsWith("image/")) return;

      setFileError(null);
      setShowProgress(true);
      const formData = new FormData();
      formData.append("file", file);

      const { data } = await axios.post(`${UNO_URL}/api/resource/ar/upload/image/${uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
      });
      setModuleDetails((prev) => ({ ...prev, thumbnail: data?.url }));
    } catch (error) {
      console.log(error);
      setKey((pre) => pre + 1);
    } finally {
      setShowProgress(false);
    }
  };

  const handleSaveBasicDetails = async () => {
    try {
      const payload = {
        name: moduleDetails?.name,
        version: {
          thumbnail: moduleDetails?.thumbnail || "",
          description: moduleDetails?.description || "",
          type: (moduleDetails.arType).map(e => e.value),
          contentMode: arContentMode
        },
      };

      await apiClient.post(`${UNO_URL}${UPDATE_AR_MODULE_DETAIL}/${uuid}`, payload);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      fetchBasicModuleDetails();
    }
  };

  let handleSaveDebounce = debounce(handleSaveBasicDetails, 500, setLoading);

  return (
    <div className={`detail-component  ${close ? "closed" : ""} `}>
      <h6>
        Basic Details
        <span className="OpenCloseBtn" onClick={() => setClose((prev) => !prev)}>
          {!close ? <FoldDown /> : <FoldRight />}
        </span>{" "}
      </h6>
      <div className="row ps-3">
        <div className="col-md-4">
          <div className="row">
            <div className="col p-0">
              {showProgress ? (
                <FileUploadProcess />
              ) : (
                <div className="modulepic justify-content-start">
                  <div className="thumbnailImageDiv">
                    {moduleDetails?.thumbnail ? (
                      <>
                        <img id="thumbnailImage" src={moduleDetails.thumbnail} alt="Uploaded Thumbnail" />
                        <span
                          className="canceldelete"
                          onClick={() => setModuleDetails((prev) => ({ ...prev, thumbnail: "" }))}
                        >
                          X
                        </span>
                      </>
                    ) : (
                      <div className="fileuploader">
                        <FileUploader
                          key={key}
                          handleChange={handleImageUpload}
                          name="thumbnailInput"
                          types={imageFileTypes}
                          label="drag & drop or choose file to upload"
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="col imgupload">
              <label className="mb-1">
                Thumbnail Image <span> * </span>
              </label>
              <p className="recommend">Max file size: {getAllowedMaxFileSize(AR_CONTENT_THUMBNAIL)}</p>
              <p className="recommend">Required Resolution* (1280px &times; 720px)</p>
              <p className="fileError">{fileError}</p>
            </div>
          </div>

          <div className="row ps-0">
            <div className="col-md-12 ps-0">
              <div className="form-group pt-2">
                <label htmlFor="exampleFormControlInput1">
                  Name <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control mt-1"
                  id="exampleFormControlInput1"
                  placeholder="Enter name"
                  value={moduleDetails.name}
                  onChange={(e) => setModuleDetails((prev) => ({ ...prev, name: e.target.value }))}
                />
              </div>
            </div>
            <div className="col-md-12 ps-0">
              <div className="form-group ps-0 pt-2">
                <label htmlFor="exampleFormControlInput1">
                  Select Type <span> * </span>
                </label>
                <Select
                  name="Object"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select AR Type"
                  createNewCustomTags
                  options={arContentTypeOptions}
                  onChange={(value) => setModuleDetails((pre) => ({ ...pre, arType: value }))}
                  value={moduleDetails.arType}
                  isMulti 
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="form-group">
            <label htmlFor="exampleFormControlDescription">Description </label>
            <textarea
              name="project_about"
              className="form-control mt-2"
              rows={8}
              id="exampleFormControlDescription"
              value={moduleDetails.description}
              onChange={(e) => setModuleDetails((prev) => ({ ...prev, description: e.target.value }))}
            />
          </div>

          <div className="row">
            <div className="col-md-6">

              {(moduleDetails?.arType).some(item => item.value === "targetBased") && <div class="form-check form-switch toggleswitchbtn">
                <label className="form-check-label thdmodel" for="flexSwitchToggle">
                  3D Model
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchToggle"
                  checked={arContentMode === "hotspot"}
                  onChange={(e) => setArContentMode(e.target.checked ? "hotspot" : "model")}
                />
                <label className="form-check-label" for="flexSwitchToggle">
                  Hotspots/Tooltips
                </label>
              </div>}

            </div>
            <div className="col-md-6">
              <div className="footerbtn flex-column align-items-end pt-3 mt-1">
                {error && <p className="text-danger m-0">Please upload 3D models</p>}
                <button onClick={handleSaveDebounce}>{loading ? <SpinnerIcon /> : "Save Details"}</button>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default ARDetails;

export const FileUploadProcess = () => {
  return (
    <>
      <div className="uploadProgressBar">
        <div className="progress mt-2" style={{ height: "10px" }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated bg-danger"
            role="progressbar"
            aria-valuenow="75"
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: "100%", height: "10px" }}
          ></div>
        </div>
        <p>
          Uploading<span className="dot-animation"></span>
        </p>
      </div>
    </>
  );
};
